import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

import { EventPageTitleComponent } from './event-page-title/event-page-title.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    imports: [
        SharedModule, MatMenuModule, MatButtonModule
    ],
    declarations: [EventPageTitleComponent],
    exports: [EventPageTitleComponent]
})
export class EventSharedModule {
}
